/* eslint-disable react/prop-types */
import React from 'react'
import { Typography } from '@telus/koodo-ui-kit'
import MultiRafCode from '@apps/components/MultiRafCode'
import MultiPromoCode from '@apps/components/MultiPromoCode'

const PromoCode = ({ onComplete, shortTextFields }) => (
  <>
    <Typography block variant={{ size: 'h4' }}>
      {shortTextFields?.promoCodesTitle}
    </Typography>
    {
      shortTextFields?.promoCallout && shortTextFields?.paymentHeaderSubTitle && (
        <div className="mt-4 mb-5">
          <Typography variant={{ size: 'small', bold: true }}>
            {shortTextFields?.promoCallout}
          </Typography>
          &nbsp;
          <Typography variant={{ size: 'small' }}>
            {shortTextFields?.paymentHeaderSubTitle}
          </Typography>
        </div>
      )
    }
    <MultiRafCode />
    <MultiPromoCode onComplete={onComplete} />
  </>
)

export default PromoCode
